import React from "react";
import MetaTags from "react-meta-tags";
import Subscribe from "../../component/Subscribe";
import "../../common/SCSS/newsletterStyle.css";
function Newsletter_45() {
  return (
    <>
      <section
        className="about-banner-section"
        style={{ padding: "150px 0 62px" }}
      >
        <div className="about-circle">
          <div className="about-circle-1"></div>
          <div className="about-circle-2"></div>
          <div className="about-circle-3"></div>
          <div className="about-circle-4"></div>
          <div className="about-circle-5"></div>
        </div>
        <div className="about-banner-container">
          <div className="about-content">
            <h1 className="about-title" style={{ paddingTop: "25px" }}>
              SustainabilityConnect
            </h1>
            <p
              className="about-description"
              style={{ fontSize: "25px", marginTop: "18px", marginBottom: "0" }}
            >
              Newsletter June 2026
            </p>
          </div>
        </div>
        <div className="about-elements">
          <div className="about-element-1"></div>
          <div className="about-element-2"></div>
          <div className="about-element-3"></div>
          <div className="about-element-4"></div>
          <div className="about-element-5"></div>
        </div>
      </section>
      <div className="newsletter-container">
        <MetaTags>
          <title>
            SBTi Unveils Enhanced Net-Zero Framework to Accelerate Corporate
            Climate Action.
          </title>
          <meta
            name="description"
            content="The Science Based Targets initiative (SBTi) has released a draft revision of its Corporate Net-Zero Standard, marking one of the most significant updates to the global framework used by businesses to align climate strategies with the Paris Agreement’s 1.5°C pathway"
          />
          <meta
            property="og:title"
            content="UpdaptCSR | Sustainability Platform"
          />
        </MetaTags>

        <div
          className="Newsletter-title1"
          style={{ paddingTop: "56px", fontSize: "32px" }}
        >
          SBTi Unveils Enhanced Net-Zero Framework to Accelerate Corporate
          Climate Action.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/June_2026_1.webp")}
            alt="SBTi Unveils Enhanced Net-Zero Framework to Accelerate Corporate Climate Action."
            loading="lazy"
          />
        </figure>
        <p>
          The Science Based Targets initiative (SBTi) has released a draft
          revision of its Corporate Net-Zero Standard, marking one of the most
          significant updates to the global framework used by businesses to
          align climate strategies with the Paris Agreement’s 1.5°C pathway. The
          revised standard aims to make science-based target setting more
          practical and accessible while maintaining a strong focus on
          real-world emissions reductions. Since its launch in 2015, SBTi has
          become the leading benchmark for corporate climate ambition, with more
          than 10,000 companies globally now operating with validated
          science-based emissions reduction targets and thousands more committed
          to setting them.
        </p>
        <p>
          A key feature of the draft standard is its enhanced approach to Scope
          3 emissions, which often account for the largest share of a company’s
          carbon footprint through supply chains, purchased goods,
          transportation, and product use. Recognising the complexity of
          value-chain decarbonization, the proposed framework introduces greater
          flexibility through mechanisms such as green procurement, supplier
          engagement programs, and revenue-based metrics for high-emitting
          sectors. The draft also proposes separate requirements for Scope 1 and
          Scope 2 emissions, improved annual progress tracking, and clearer
          expectations around corporate transition plans, helping companies
          translate long-term commitments into measurable action.
        </p>
        <p>
          The updated framework further reflects the growing maturity of
          corporate climate governance by introducing differentiated pathways
          based on company size, geography, and operational complexity. The
          proposal includes tailored requirements for small and medium-sized
          enterprises and organizations in emerging markets, enabling broader
          participation in science-based climate action. In addition, the draft
          explores the role of carbon removals for addressing residual emissions
          and provides greater guidance on climate finance and implementation
          measures.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The revised SBTi Net-Zero Standard is expected to accelerate
            decarbonization efforts across industries by providing more
            practical and flexible pathways for managing value-chain emissions.
            Sectors with complex supply chains, including manufacturing,
            consumer goods, technology, and retail, could benefit from clearer
            Scope 3 requirements and enhanced supplier engagement mechanisms.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          France Sets Structured Pathway to Fossil-Free Energy by 2050.
        </div>
        <div className="Newsletter-picture">
          <figure style={{ marginTop: "25px" }}>
            <img
              className="picture"
              src={require("../../../../../assets/Newsletter/June_2026_2.webp")}
              alt="France Sets Structured Pathway to Fossil-Free Energy by 2050. "
              loading="lazy"
            />
          </figure>
        </div>
        <p>
          France has announced a detailed national roadmap to phase out fossil
          fuels for energy use by 2050, becoming one of the first major
          economies to establish explicit timelines for coal, oil and fossil gas
          consumption. The roadmap consolidates existing climate, energy and
          industrial policies into a single framework, setting
          end-of-consumption targets for coal by 2030, oil by 2045 and fossil
          gas by 2050. Interim milestones aim to reduce fossil fuels from nearly
          60% of final energy consumption in 2023 to 40% by 2030 and 30% by
          2035, aligning with the country’s broader objective of achieving
          carbon neutrality by mid-century.
        </p>
        <p>
          The strategy is closely linked to energy security and industrial
          competitiveness. France currently imports the vast majority of its
          fossil fuels, including nearly all of its fossil gas requirements. To
          reduce this dependence, the roadmap outlines measures to replace 85
          terawatt-hours of gas imports with domestically produced energy by
          2030. Planned actions include the closure of the country’s remaining
          coal-fired power plants by 2027, accelerated electrification across
          transport and industry, and a nationwide expansion of low-carbon
          heating solutions. New gas boiler installations in residential and
          commercial buildings are expected to be prohibited from the end of
          2026, while deployment of heat pumps is targeted to reach one million
          units annually by 2030.
        </p>
        <p>
          The roadmap builds on France’s longstanding energy transition efforts
          and the advantages of an electricity system already dominated by
          low-carbon generation. Renewable and nuclear sources accounted for
          approximately 95% of national electricity production in 2024,
          providing a strong foundation for the electrification of transport,
          buildings and industrial processes. Historical progress has also been
          notable, with fossil fuel consumption in buildings declining by more
          than 40% between 2017 and 2022 and renewable energy contributing 22.2%
          of gross final energy consumption in 2023. Looking ahead, the
          government’s electrification strategy anticipates a roughly 30%
          increase in electricity demand by 2035, supported by investments in
          electric mobility, charging infrastructure, energy efficiency upgrades
          and domestic clean energy production.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Beyond emissions reduction, the roadmap is expected to strengthen
            France’s energy security by lowering dependence on imported fossil
            fuels and reducing exposure to global fuel price volatility. The
            initiative is also likely to stimulate investment in renewable
            energy, electrification technologies, clean transport and
            energy-efficient infrastructure, supporting industrial
            competitiveness and job creation. Increased deployment of domestic
            low-carbon energy sources can enhance long-term energy resilience
            while helping businesses and households transition toward a more
            stable and sustainable energy system.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Germany Expands Industrial Decarbonisation Push with €5 Billion CCfD
          Scheme
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/June_2026_3.webp")}
            alt="Germany Expands Industrial Decarbonisation Push with €5 Billion CCfD Scheme"
            loading="lazy"
          />
        </figure>
        <p>
          Germany has opened a new €5 billion funding round to accelerate
          low-carbon transformation across energy-intensive industries,
          including chemicals, metals, cement, lime, glass, paper and ceramics.
          The programme uses 15-year carbon contracts for difference, helping
          companies bridge the cost gap between conventional production and
          cleaner technologies while keeping industrial investment anchored in
          Germany.
        </p>
        <p>
          The scheme supports electrification, hydrogen-based processes, energy
          efficiency, carbon capture and storage, and carbon capture
          utilisation. Projects will be selected through competitive bidding,
          with priority given to the lowest public support requested per tonne
          of avoided CO2. Updated rules require at least a 50% emissions
          reduction within four years and 85% by the final contract year.
        </p>
        <p>
          Germany's latest funding round builds on a broader industrial
          decarbonisation strategy that has been evolving over the past several
          years. The country's climate contracts programme was first introduced
          to provide long-term investment certainty for hard-to-abate sectors
          that collectively account for a significant share of industrial
          greenhouse gas emissions. Earlier funding rounds attracted strong
          industry participation, with projects spanning green hydrogen
          adoption, electrified production processes, waste heat recovery, and
          carbon capture technologies. According to government data, more than
          130 project proposals were submitted during the preparatory phase of
          the current programme, reflecting growing corporate interest in
          low-carbon manufacturing pathways.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The initiative is aligned with Germany's target of reducing
            greenhouse gas emissions by 65% by 2030 compared with 1990 levels
            and achieving climate neutrality by 2045. By offering long-term
            support mechanisms and technology-neutral funding, the programme is
            expected to facilitate large-scale deployment of emerging industrial
            decarbonisation technologies while strengthening the competitiveness
            of domestic manufacturing sectors in the transition to a low-carbon
            economy.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          China, European Union and Brazil Launch Global Coalition to Strengthen
          Carbon Pricing Frameworks.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/June_2026_4.webp")}
            alt="China, European Union and Brazil Launch Global Coalition to Strengthen Carbon Pricing Frameworks."
            loading="lazy"
          />
        </figure>
        <p>
          China, the European Union and Brazil have jointly launched the Open
          Coalition on Compliance Carbon Markets, a new international initiative
          aimed at enhancing cooperation among jurisdictions that operate carbon
          pricing mechanisms. The coalition seeks to promote greater alignment
          in the design and implementation of emissions trading systems (ETS)
          and carbon pricing policies, creating a platform for knowledge
          sharing, technical collaboration and capacity building. Germany and
          New Zealand have joined as founding participants, while additional
          countries are expected to engage as carbon markets continue to expand
          globally.
        </p>
        <p>
          The coalition will prioritise collaboration on key areas such as
          monitoring, reporting and verification (MRV) systems, carbon
          accounting methodologies, market governance, registry interoperability
          and the development of high-integrity carbon credits. These efforts
          are expected to improve transparency and strengthen confidence in
          compliance carbon markets, while supporting countries in meeting their
          climate commitments under the Paris Agreement.
        </p>
        <p>
          The launch comes as carbon pricing continues to gain momentum
          worldwide. According to World Bank data, carbon taxes and emissions
          trading systems now cover nearly 30% of global greenhouse gas
          emissions, generating more than US$100 billion in annual revenues.
          China operates the world’s largest emissions trading market by covered
          emissions and recently expanded its ETS to include the steel, cement
          and aluminium sectors. Brazil has also advanced its regulated carbon
          market framework in recent years, while the European Union continues
          to enhance its carbon market architecture through measures such as the
          Carbon Border Adjustment Mechanism (CBAM), reinforcing the growing
          importance of carbon pricing as a key policy instrument in the global
          climate transition.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The launch of the coalition is expected to enhance transparency,
            consistency and interoperability across international carbon
            markets, helping reduce regulatory fragmentation and improving
            investor confidence. Greater alignment between major economies such
            as China, Brazil and the European Union could facilitate
            cross-border trade, encourage low-carbon investments and support the
            development of more robust carbon pricing mechanisms globally. As
            carbon markets expand, the initiative may also contribute to more
            efficient emissions reduction efforts and strengthen the role of
            market-based climate policies in international economic and
            sustainability frameworks.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Singapore and World Bank Launch New Programme to Scale High-Integrity
          Carbon Markets.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/June_2026_5.webp")}
            alt="Singapore and World Bank Launch New Programme to Scale High-Integrity Carbon Markets. "
            loading="lazy"
          />
        </figure>

        <p>
          The Government of Singapore and the World Bank Group have launched the
          Singapore Carbon Markets Programme, a strategic initiative designed to
          strengthen the integrity of international carbon markets and improve
          access to climate finance. Announced at Innovate4Climate 2026, the
          programme will support countries in developing robust carbon market
          frameworks, enhancing institutional capabilities, and attracting
          private-sector investment for climate mitigation projects. The
          initiative reflects growing global efforts to operationalise Article 6
          of the Paris Agreement and scale market-based solutions that can help
          accelerate emissions reductions while supporting sustainable economic
          development.
        </p>
        <p>
          A central objective of the programme is the development of
          interoperable carbon registries and advanced digital monitoring,
          reporting and verification (MRV) systems to improve transparency,
          traceability and market confidence. The programme will also support
          the generation and monetisation of high-integrity carbon credits,
          including those derived from nature-based solutions and regenerative
          agriculture. By strengthening market infrastructure and reducing
          transaction barriers, the initiative seeks to facilitate greater
          participation from governments, project developers, investors and
          carbon credit buyers.
        </p>
        <p>
          The launch comes amid increasing global momentum for carbon pricing
          and climate finance mechanisms. According to the World Bank’s latest
          assessments, carbon pricing instruments now cover approximately 28% of
          global greenhouse gas emissions and generated more than US$100 billion
          in revenue in 2024. Singapore has continued to strengthen its position
          as a leading carbon services and climate finance hub through bilateral
          carbon credit agreements, a progressive carbon tax framework and
          investments in market infrastructure, supporting the development of
          credible and transparent carbon markets across the Asia-Pacific
          region.
        </p>
        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The programme is expected to strengthen carbon market participation
            across Asian economies by improving access to climate finance,
            enhancing carbon credit integrity, and supporting the development of
            transparent market infrastructure. It could help accelerate
            investments in renewable energy, nature-based solutions, and
            low-carbon technologies, while enabling countries to advance their
            climate and sustainability goals more effectively.
          </p>
        </div>
      </div>
      <Subscribe />
    </>
  );
}

export default Newsletter_45;
